import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { GameCurrency } from 'modules/game-payments/components';

interface ComponentProps {
  entryFee: number;
  label: string;
}

export const PayWithRewardActionText: FC<ComponentProps> = ({ label, entryFee }) => {
  return (
    <Typography>
      {label}
      {entryFee ? (
        <>
          <Typography component="span" sx={{ textTransform: 'none' }}>
            {' for '}
          </Typography>
          <GameCurrency amount={entryFee} />
          <Typography component="span" sx={{ textTransform: 'none' }}>
            {' '}
            with Reward Balance
          </Typography>
        </>
      ) : null}
    </Typography>
  );
};
